export function vibrate(pattern: number | number[] = 30): void {
	window?.navigator?.vibrate?.(pattern);
}
